// ╔═══════════════════════════════════════════════════════════════════════════╗
// ║                                                                           ║
// ║   FORM DATA - Dropdown Options for Legal Filing Platform                  ║
// ║   Edit this file to update all select/dropdown options                    ║
// ║                                                                           ║
// ╚═══════════════════════════════════════════════════════════════════════════╝

export const FormData = {
  
  // ─────────────────────────────────────────────────────────────────────────
  // JURISDICTIONS
  // ─────────────────────────────────────────────────────────────────────────
  jurisdictions: [
    { value: '', label: 'Select jurisdiction...' },
    { value: 'state', label: 'State' },
    { value: 'federal', label: 'Federal' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // US STATES
  // ─────────────────────────────────────────────────────────────────────────
  states: [
    { value: '', label: 'Select state...' },
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'DC', label: 'District of Columbia' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // CALIFORNIA COURTS (Most common - add other states as needed)
  // ─────────────────────────────────────────────────────────────────────────
  courts: {
    CA: [
      { value: '', label: 'Select court...' },
      // Superior Courts by County
      { value: 'ca-alameda-superior', label: 'Alameda County Superior Court' },
      { value: 'ca-alpine-superior', label: 'Alpine County Superior Court' },
      { value: 'ca-amador-superior', label: 'Amador County Superior Court' },
      { value: 'ca-butte-superior', label: 'Butte County Superior Court' },
      { value: 'ca-calaveras-superior', label: 'Calaveras County Superior Court' },
      { value: 'ca-colusa-superior', label: 'Colusa County Superior Court' },
      { value: 'ca-contracosta-superior', label: 'Contra Costa County Superior Court' },
      { value: 'ca-delnorte-superior', label: 'Del Norte County Superior Court' },
      { value: 'ca-eldorado-superior', label: 'El Dorado County Superior Court' },
      { value: 'ca-fresno-superior', label: 'Fresno County Superior Court' },
      { value: 'ca-glenn-superior', label: 'Glenn County Superior Court' },
      { value: 'ca-humboldt-superior', label: 'Humboldt County Superior Court' },
      { value: 'ca-imperial-superior', label: 'Imperial County Superior Court' },
      { value: 'ca-inyo-superior', label: 'Inyo County Superior Court' },
      { value: 'ca-kern-superior', label: 'Kern County Superior Court' },
      { value: 'ca-kings-superior', label: 'Kings County Superior Court' },
      { value: 'ca-lake-superior', label: 'Lake County Superior Court' },
      { value: 'ca-lassen-superior', label: 'Lassen County Superior Court' },
      { value: 'ca-losangeles-superior', label: 'Los Angeles County Superior Court' },
      { value: 'ca-madera-superior', label: 'Madera County Superior Court' },
      { value: 'ca-marin-superior', label: 'Marin County Superior Court' },
      { value: 'ca-mariposa-superior', label: 'Mariposa County Superior Court' },
      { value: 'ca-mendocino-superior', label: 'Mendocino County Superior Court' },
      { value: 'ca-merced-superior', label: 'Merced County Superior Court' },
      { value: 'ca-modoc-superior', label: 'Modoc County Superior Court' },
      { value: 'ca-mono-superior', label: 'Mono County Superior Court' },
      { value: 'ca-monterey-superior', label: 'Monterey County Superior Court' },
      { value: 'ca-napa-superior', label: 'Napa County Superior Court' },
      { value: 'ca-nevada-superior', label: 'Nevada County Superior Court' },
      { value: 'ca-orange-superior', label: 'Orange County Superior Court' },
      { value: 'ca-placer-superior', label: 'Placer County Superior Court' },
      { value: 'ca-plumas-superior', label: 'Plumas County Superior Court' },
      { value: 'ca-riverside-superior', label: 'Riverside County Superior Court' },
      { value: 'ca-sacramento-superior', label: 'Sacramento County Superior Court' },
      { value: 'ca-sanbenito-superior', label: 'San Benito County Superior Court' },
      { value: 'ca-sanbernardino-superior', label: 'San Bernardino County Superior Court' },
      { value: 'ca-sandiego-superior', label: 'San Diego County Superior Court' },
      { value: 'ca-sanfrancisco-superior', label: 'San Francisco County Superior Court' },
      { value: 'ca-sanjoaquin-superior', label: 'San Joaquin County Superior Court' },
      { value: 'ca-sanluisobispo-superior', label: 'San Luis Obispo County Superior Court' },
      { value: 'ca-sanmateo-superior', label: 'San Mateo County Superior Court' },
      { value: 'ca-santabarbara-superior', label: 'Santa Barbara County Superior Court' },
      { value: 'ca-santaclara-superior', label: 'Santa Clara County Superior Court' },
      { value: 'ca-santacruz-superior', label: 'Santa Cruz County Superior Court' },
      { value: 'ca-shasta-superior', label: 'Shasta County Superior Court' },
      { value: 'ca-sierra-superior', label: 'Sierra County Superior Court' },
      { value: 'ca-siskiyou-superior', label: 'Siskiyou County Superior Court' },
      { value: 'ca-solano-superior', label: 'Solano County Superior Court' },
      { value: 'ca-sonoma-superior', label: 'Sonoma County Superior Court' },
      { value: 'ca-stanislaus-superior', label: 'Stanislaus County Superior Court' },
      { value: 'ca-sutter-superior', label: 'Sutter County Superior Court' },
      { value: 'ca-tehama-superior', label: 'Tehama County Superior Court' },
      { value: 'ca-trinity-superior', label: 'Trinity County Superior Court' },
      { value: 'ca-tulare-superior', label: 'Tulare County Superior Court' },
      { value: 'ca-tuolumne-superior', label: 'Tuolumne County Superior Court' },
      { value: 'ca-ventura-superior', label: 'Ventura County Superior Court' },
      { value: 'ca-yolo-superior', label: 'Yolo County Superior Court' },
      { value: 'ca-yuba-superior', label: 'Yuba County Superior Court' },
      // Appellate Courts
      { value: 'ca-appeals-1st', label: 'Court of Appeal, First Appellate District' },
      { value: 'ca-appeals-2nd', label: 'Court of Appeal, Second Appellate District' },
      { value: 'ca-appeals-3rd', label: 'Court of Appeal, Third Appellate District' },
      { value: 'ca-appeals-4th', label: 'Court of Appeal, Fourth Appellate District' },
      { value: 'ca-appeals-5th', label: 'Court of Appeal, Fifth Appellate District' },
      { value: 'ca-appeals-6th', label: 'Court of Appeal, Sixth Appellate District' },
      { value: 'ca-supreme', label: 'Supreme Court of California' },
    ],
    // Add more states as needed
    NY: [
      { value: '', label: 'Select court...' },
      { value: 'ny-albany-supreme', label: 'Albany County Supreme Court' },
      { value: 'ny-bronx-supreme', label: 'Bronx County Supreme Court' },
      { value: 'ny-kings-supreme', label: 'Kings County Supreme Court' },
      { value: 'ny-newyork-supreme', label: 'New York County Supreme Court' },
      { value: 'ny-queens-supreme', label: 'Queens County Supreme Court' },
      { value: 'ny-richmond-supreme', label: 'Richmond County Supreme Court' },
      { value: 'ny-nassau-supreme', label: 'Nassau County Supreme Court' },
      { value: 'ny-suffolk-supreme', label: 'Suffolk County Supreme Court' },
      { value: 'ny-westchester-supreme', label: 'Westchester County Supreme Court' },
      { value: 'ny-appeals', label: 'New York Court of Appeals' },
    ],
    TX: [
      { value: '', label: 'Select court...' },
      { value: 'tx-harris-district', label: 'Harris County District Court' },
      { value: 'tx-dallas-district', label: 'Dallas County District Court' },
      { value: 'tx-tarrant-district', label: 'Tarrant County District Court' },
      { value: 'tx-bexar-district', label: 'Bexar County District Court' },
      { value: 'tx-travis-district', label: 'Travis County District Court' },
      { value: 'tx-supreme', label: 'Supreme Court of Texas' },
    ],
    FL: [
      { value: '', label: 'Select court...' },
      { value: 'fl-miamidade-circuit', label: 'Miami-Dade County Circuit Court' },
      { value: 'fl-broward-circuit', label: 'Broward County Circuit Court' },
      { value: 'fl-palmbeach-circuit', label: 'Palm Beach County Circuit Court' },
      { value: 'fl-hillsborough-circuit', label: 'Hillsborough County Circuit Court' },
      { value: 'fl-orange-circuit', label: 'Orange County Circuit Court' },
      { value: 'fl-supreme', label: 'Supreme Court of Florida' },
    ],
  },

  // ─────────────────────────────────────────────────────────────────────────
  // COURT LOCATIONS (by court)
  // ─────────────────────────────────────────────────────────────────────────
  courtLocations: {
    'ca-losangeles-superior': [
      { value: '', label: 'Select location...' },
      { value: 'stanley-mosk', label: 'Stanley Mosk Courthouse - 111 N Hill St, Los Angeles' },
      { value: 'central-civil-west', label: 'Central Civil West - 600 S Commonwealth Ave, Los Angeles' },
      { value: 'spring-street', label: 'Spring Street Courthouse - 312 N Spring St, Los Angeles' },
      { value: 'burbank', label: 'Burbank Courthouse - 300 E Olive Ave, Burbank' },
      { value: 'compton', label: 'Compton Courthouse - 200 W Compton Blvd, Compton' },
      { value: 'downey', label: 'Downey Courthouse - 7500 E Imperial Hwy, Downey' },
      { value: 'glendale', label: 'Glendale Courthouse - 600 E Broadway, Glendale' },
      { value: 'inglewood', label: 'Inglewood Courthouse - 1 E Regent St, Inglewood' },
      { value: 'long-beach', label: 'Long Beach Courthouse - 275 Magnolia Ave, Long Beach' },
      { value: 'norwalk', label: 'Norwalk Courthouse - 12720 Norwalk Blvd, Norwalk' },
      { value: 'pasadena', label: 'Pasadena Courthouse - 300 E Walnut St, Pasadena' },
      { value: 'pomona', label: 'Pomona Courthouse South - 400 Civic Center Plaza, Pomona' },
      { value: 'santa-monica', label: 'Santa Monica Courthouse - 1725 Main St, Santa Monica' },
      { value: 'torrance', label: 'Torrance Courthouse - 825 Maple Ave, Torrance' },
      { value: 'van-nuys-east', label: 'Van Nuys Courthouse East - 6230 Sylmar Ave, Van Nuys' },
      { value: 'van-nuys-west', label: 'Van Nuys Courthouse West - 14400 Erwin St Mall, Van Nuys' },
    ],
    'ca-orange-superior': [
      { value: '', label: 'Select location...' },
      { value: 'central-justice', label: 'Central Justice Center - 700 Civic Center Dr W, Santa Ana' },
      { value: 'harbor-justice', label: 'Harbor Justice Center - 4601 Jamboree Rd, Newport Beach' },
      { value: 'north-justice', label: 'North Justice Center - 1275 N Berkeley Ave, Fullerton' },
      { value: 'west-justice', label: 'West Justice Center - 8141 13th St, Westminster' },
      { value: 'lamoreaux-justice', label: 'Lamoreaux Justice Center - 341 The City Dr S, Orange' },
    ],
    'ca-sandiego-superior': [
      { value: '', label: 'Select location...' },
      { value: 'central', label: 'Central Courthouse - 1100 Union St, San Diego' },
      { value: 'hall-of-justice', label: 'Hall of Justice - 330 W Broadway, San Diego' },
      { value: 'north-county', label: 'North County Regional Center - 325 S Melrose Dr, Vista' },
      { value: 'south-county', label: 'South County Regional Center - 500 Third Ave, Chula Vista' },
      { value: 'east-county', label: 'East County Regional Center - 250 E Main St, El Cajon' },
    ],
    'ca-sanfrancisco-superior': [
      { value: '', label: 'Select location...' },
      { value: 'civic-center', label: 'Civic Center Courthouse - 400 McAllister St, San Francisco' },
      { value: 'hall-of-justice', label: 'Hall of Justice - 850 Bryant St, San Francisco' },
    ],
    // Default for courts without specific locations
    'default': [
      { value: '', label: 'Select location...' },
      { value: 'main', label: 'Main Courthouse' },
    ],
  },

  // ─────────────────────────────────────────────────────────────────────────
  // FEDERAL COURTS
  // ─────────────────────────────────────────────────────────────────────────
  federalCourts: [
    { value: '', label: 'Select federal court...' },
    // District Courts - California
    { value: 'usdc-ca-central', label: 'U.S. District Court - Central District of California' },
    { value: 'usdc-ca-eastern', label: 'U.S. District Court - Eastern District of California' },
    { value: 'usdc-ca-northern', label: 'U.S. District Court - Northern District of California' },
    { value: 'usdc-ca-southern', label: 'U.S. District Court - Southern District of California' },
    // District Courts - Other major states
    { value: 'usdc-ny-eastern', label: 'U.S. District Court - Eastern District of New York' },
    { value: 'usdc-ny-northern', label: 'U.S. District Court - Northern District of New York' },
    { value: 'usdc-ny-southern', label: 'U.S. District Court - Southern District of New York' },
    { value: 'usdc-ny-western', label: 'U.S. District Court - Western District of New York' },
    { value: 'usdc-tx-eastern', label: 'U.S. District Court - Eastern District of Texas' },
    { value: 'usdc-tx-northern', label: 'U.S. District Court - Northern District of Texas' },
    { value: 'usdc-tx-southern', label: 'U.S. District Court - Southern District of Texas' },
    { value: 'usdc-tx-western', label: 'U.S. District Court - Western District of Texas' },
    { value: 'usdc-fl-middle', label: 'U.S. District Court - Middle District of Florida' },
    { value: 'usdc-fl-northern', label: 'U.S. District Court - Northern District of Florida' },
    { value: 'usdc-fl-southern', label: 'U.S. District Court - Southern District of Florida' },
    // Circuit Courts of Appeals
    { value: 'usca-1st', label: 'U.S. Court of Appeals - First Circuit' },
    { value: 'usca-2nd', label: 'U.S. Court of Appeals - Second Circuit' },
    { value: 'usca-3rd', label: 'U.S. Court of Appeals - Third Circuit' },
    { value: 'usca-4th', label: 'U.S. Court of Appeals - Fourth Circuit' },
    { value: 'usca-5th', label: 'U.S. Court of Appeals - Fifth Circuit' },
    { value: 'usca-6th', label: 'U.S. Court of Appeals - Sixth Circuit' },
    { value: 'usca-7th', label: 'U.S. Court of Appeals - Seventh Circuit' },
    { value: 'usca-8th', label: 'U.S. Court of Appeals - Eighth Circuit' },
    { value: 'usca-9th', label: 'U.S. Court of Appeals - Ninth Circuit' },
    { value: 'usca-10th', label: 'U.S. Court of Appeals - Tenth Circuit' },
    { value: 'usca-11th', label: 'U.S. Court of Appeals - Eleventh Circuit' },
    { value: 'usca-dc', label: 'U.S. Court of Appeals - District of Columbia Circuit' },
    { value: 'usca-federal', label: 'U.S. Court of Appeals - Federal Circuit' },
    // Supreme Court
    { value: 'scotus', label: 'Supreme Court of the United States' },
    // Bankruptcy Courts
    { value: 'bk-ca-central', label: 'U.S. Bankruptcy Court - Central District of California' },
    { value: 'bk-ca-eastern', label: 'U.S. Bankruptcy Court - Eastern District of California' },
    { value: 'bk-ca-northern', label: 'U.S. Bankruptcy Court - Northern District of California' },
    { value: 'bk-ca-southern', label: 'U.S. Bankruptcy Court - Southern District of California' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // ORDER TYPES
  // ─────────────────────────────────────────────────────────────────────────
  orderTypes: [
    { value: '', label: 'Any type' },
    { value: 'e-filing', label: 'eFiling' },
    { value: 'court-filing', label: 'Court Filing' },
    { value: 'process-serving', label: 'Process Serving' },
    { value: 'eservice', label: 'eService' },
    { value: 'delivery', label: 'Delivery' },
    { value: 'skip-trace', label: 'Skip Trace / Locate' },
    { value: 'concierge', label: 'Concierge' },
    { value: 'document-retrieval', label: 'Document Retrieval' },
    { value: 'courtesy-copy-delivery', label: 'Courtesy Copy Delivery' },
    { value: 'secretary-of-state-filing', label: 'Secretary of State Filing' },
    { value: 'county-recording', label: 'County Recording' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // ORDER STATUS
  // ─────────────────────────────────────────────────────────────────────────
  orderStatuses: [
    { value: '', label: 'Any status' },
    { value: 'draft', label: 'Draft' },
    { value: 'submitted', label: 'Submitted' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'pending-review', label: 'Pending Review' },
    { value: 'accepted', label: 'Accepted' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // MATTER STATUS
  // ─────────────────────────────────────────────────────────────────────────
  matterStatuses: [
    { value: '', label: 'Any status' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'closed', label: 'Closed' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // NOTICE TYPES (for Service of Process - Other Notice)
  // ─────────────────────────────────────────────────────────────────────────
  noticeTypes: [
    { value: '', label: 'Select notice type...' },
    { value: 'collection', label: 'Collection Notice' },
    { value: 'eviction', label: 'Notice to Vacate / Eviction' },
    { value: 'demand', label: 'Demand Letter' },
    { value: '3-day-notice', label: '3-Day Notice to Pay or Quit' },
    { value: '30-day-notice', label: '30-Day Notice to Terminate' },
    { value: '60-day-notice', label: '60-Day Notice to Terminate' },
    { value: '90-day-notice', label: '90-Day Notice to Terminate' },
    { value: 'cease-desist', label: 'Cease and Desist' },
    { value: 'lien-notice', label: 'Lien Notice' },
    { value: 'foreclosure', label: 'Foreclosure Notice' },
    { value: 'other', label: 'Other' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // PARTY TYPES
  // ─────────────────────────────────────────────────────────────────────────
  partyTypes: [
    { value: 'individual', label: 'Individual' },
    { value: 'business', label: 'Business' },
    { value: 'attorney', label: 'Attorney' },
    { value: 'government', label: 'Government Agency' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // ADDRESS TYPES
  // ─────────────────────────────────────────────────────────────────────────
  addressTypes: [
    { value: 'home', label: 'Home / Residence' },
    { value: 'work', label: 'Work / Business' },
    { value: 'mailing', label: 'Mailing Address' },
    { value: 'registered-agent', label: 'Registered Agent' },
    { value: 'other', label: 'Other' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // CONTACT TYPES
  // ─────────────────────────────────────────────────────────────────────────
  contactTypes: [
    { value: 'attorney', label: 'Attorney' },
    { value: 'paralegal', label: 'Paralegal' },
    { value: 'legal-assistant', label: 'Legal Assistant' },
    { value: 'office-manager', label: 'Office Manager' },
    { value: 'billing', label: 'Billing Contact' },
    { value: 'admin', label: 'Administrator' },
    { value: 'other', label: 'Other' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // FIRM LOCATIONS
  // ─────────────────────────────────────────────────────────────────────────
  firmLocations: [
    { value: 'main', label: 'MAIN' },
    { value: 'branch-1', label: 'Branch Office 1' },
    { value: 'branch-2', label: 'Branch Office 2' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // CASE CATEGORIES
  // ─────────────────────────────────────────────────────────────────────────
  caseCategories: [
    { value: '', label: 'Select case category...' },
    { value: 'civil', label: 'Civil' },
    { value: 'civil-limited', label: 'Civil Limited (Under $25,000)' },
    { value: 'civil-unlimited', label: 'Civil Unlimited ($25,000+)' },
    { value: 'small-claims', label: 'Small Claims' },
    { value: 'family', label: 'Family Law' },
    { value: 'probate', label: 'Probate' },
    { value: 'criminal', label: 'Criminal' },
    { value: 'traffic', label: 'Traffic' },
    { value: 'juvenile', label: 'Juvenile' },
    { value: 'mental-health', label: 'Mental Health' },
    { value: 'appellate', label: 'Appellate' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // FILING TYPES
  // ─────────────────────────────────────────────────────────────────────────
  filingTypes: [
    { value: '', label: 'Select filing type...' },
    { value: 'complaint', label: 'Complaint' },
    { value: 'answer', label: 'Answer' },
    { value: 'motion', label: 'Motion' },
    { value: 'reply', label: 'Reply' },
    { value: 'opposition', label: 'Opposition' },
    { value: 'declaration', label: 'Declaration' },
    { value: 'stipulation', label: 'Stipulation' },
    { value: 'notice', label: 'Notice' },
    { value: 'subpoena', label: 'Subpoena' },
    { value: 'proof-of-service', label: 'Proof of Service' },
    { value: 'judgment', label: 'Judgment' },
    { value: 'order', label: 'Order' },
    { value: 'writ', label: 'Writ' },
    { value: 'petition', label: 'Petition' },
    { value: 'response', label: 'Response' },
    { value: 'other', label: 'Other' },
  ],

  // ─────────────────────────────────────────────────────────────────────────
  // ITEMS PER PAGE OPTIONS
  // ─────────────────────────────────────────────────────────────────────────
  itemsPerPage: [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
  ],
};

interface SelectOption {
  value: string;
  label: string;
}

type StateCode = keyof typeof FormData.courts;
type CourtLocationKey = keyof typeof FormData.courtLocations;

// Helper function to get courts by state
export const getCourtsByState = (stateCode: string): SelectOption[] => {
  return FormData.courts[stateCode as StateCode] || [{ value: '', label: 'Select court...' }];
};

// Helper function to get court locations
export const getCourtLocations = (courtValue: string): SelectOption[] => {
  return FormData.courtLocations[courtValue as CourtLocationKey] || FormData.courtLocations['default'];
};

// ─────────────────────────────────────────────────────────────────────────
// JOB ROLES (for registration)
// ─────────────────────────────────────────────────────────────────────────
export const jobRoles = [
  { value: '', label: 'Select the option that most closely matches your job title' },
  { value: 'attorney', label: 'Attorney' },
  { value: 'paralegal', label: 'Paralegal' },
  { value: 'assistant', label: "Attorney's Assistant" },
  { value: 'other', label: 'Other' },
];

// ─────────────────────────────────────────────────────────────────────────
// ALL US STATES (for registration - includes DC)
// ─────────────────────────────────────────────────────────────────────────
export const allStates = [
  { value: '', label: 'Select your state of record' },
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

